import $ from "jquery";
import Vue from "vue";
import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "../stores/plugins/plugin-persisted-state";
import VueKonva from "vue-konva";

import UploadPage from "../components/upload_page.vue";
import NewUploadPage from "../components/upload/page.vue";

import Flipper from "@/modules/flipper";
import User from "@/modules/user";

import { getUploaderTranslations } from "./get_meta";

var uploader = null;

const isNewEditorEnabled = Flipper.isEnabled("new_editor");
// const isOnOldUploadPage = window.location.pathname.endsWith("/uploads");
const isOnNewUploadPage = window.location.pathname.endsWith("/upload");
const isOnHomepage = window.location.pathname === User.homeUrl();
const isOnTargetGroupPage = window.location.pathname.includes("/g/") || window.location.pathname.includes("/lp/");
// const hasNewUploads = User.hasNewUploads();
// const hasOldUploads = User.hasOldUploads();
const isInMobileApp = User.mobileApp();

const urlParams = new URLSearchParams(window.location.search);
const showNewUploads = urlParams.get("showNewUploads") === "true";
const showOldUploads = urlParams.get("showOldUploads") === "true";

let showNewEditor = ((isOnNewUploadPage && isNewEditorEnabled) || (isOnHomepage && isNewEditorEnabled) || (isOnTargetGroupPage && isNewEditorEnabled) || showNewUploads) && !showOldUploads;
showNewEditor = showNewEditor && !isInMobileApp;

function initUploader(el) {
  if (showNewEditor) {
    const app = createApp(NewUploadPage);
    const pinia = createPinia();
    pinia.use(piniaPluginPersistedstate);
    app.use(pinia);
    app.use(VueKonva);
    app.provide("I18n", window.I18n);
    uploader = app.mount(el);
  } else {
    uploader = new Vue({
      el,
      render: (h) =>
        h(UploadPage, {
          ref: "uploadpage",
          props: {
            t: getUploaderTranslations(),
            fullImageId: el.dataset.fullImageId,
            showFreeCreditInfoOnMount: el.dataset.firstSignin === "true",
          },
        }),
    });
  }
}

window.addEventListener("popstate", (event) => {
  location.reload();
});

export function showUploadPage() {
  if (!uploader) {
    var t = getUploaderTranslations();
    if (showNewEditor) {
      window.history.pushState({}, t.title, t.new_editor_url);
      $("#page-content").html("<div class='prism'><div class='upload-page-wrapper'></div></div>");
      initUploader($(".upload-page-wrapper")[0]);
      // $("footer").remove();
    } else {
      window.history.pushState({}, t.title, t.new_editor_url);

      var canonical = $("link[rel='canonical']");
      if (canonical.length == 0) {
        canonical = $("<link rel='canonical' />");
        $("head").append(canonical);
      }
      canonical.attr("href", t.url);

      var meta_description = $("meta[name='description']");
      if (meta_description.length == 0) {
        meta_description = $("<meta rel='description' />");
        $("head").append(meta_description);
      }
      meta_description.attr("content", t.meta_description);

      $("#page-content").html("<div class='upload-page-wrapper'></div>");
      initUploader($(".upload-page-wrapper")[0]);
      console.log("showUploadPage");
    }
  }
}

export function uploadFile(file) {
  showUploadPage();

  if (showNewEditor) {
    uploader.filePicked(file);
  } else {
    uploader.$refs.uploadpage.filePicked(file);
  }
}

export function uploadBase64(filename, mimetype, base64) {
  showUploadPage();
  if (showNewEditor) {
    uploader.filePickedBase64(filename, mimetype, base64);
  } else {
    uploader.$refs.uploadpage.filePickedBase64(filename, mimetype, base64);
  }
}

export function uploadUrl(url) {
  showUploadPage();
  if (showNewEditor) {
    uploader.urlPicked(url);
  } else {
    uploader.$refs.uploadpage.urlPicked(url);
  }
}

export function uploadExample(example) {
  showUploadPage();
  if (showNewEditor) {
    uploader.examplePicked(example);
  } else {
    uploader.$refs.uploadpage.examplePicked(example);
  }
}

$(() => {
  var uploader = $(".upload-page-wrapper");
  if (uploader.length == 0) return;
  initUploader(uploader[0]);

  //remove any showNewUploads or showOldUploads params from the url
  var url = new URL(window.location.href);
  url.searchParams.delete("showNewUploads");
  url.searchParams.delete("showOldUploads");
  window.history.replaceState({}, "", url.href);
});
